// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    accessor: 'name',
    // 
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />,
    accessor: 'email',
    
  },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Gender' className='min-w-125px' />,
  //   accessor: 'gender',
  //   
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Contact' className='min-w-125px' />,
    accessor: 'primary_contact',
    // Cell: ({...props}) => <><strong>Primary Contact</strong>: {props.data[props.row.index].primary_contact} <br /> <strong>Primary Contact</strong>: {props.data[props.row.index].secondary_contact}  </>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
    accessor: 'vendor_type',
    Cell: ({...props}) => {return props.data[props.row.index]?.vendor_type ? props.data[props.row.index]?.vendor_type.toUpperCase(): ''} 
  },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />,
  //   accessor: 'status',
  //   Cell: ({...props}) => <StatusCell brand={props.data[props.row.index]} />,
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,
  },
]

export {usersColumns}
